import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { signalsQueryKeys } from "./key-factory";

export const useAccountSignalSettingsQuery = () => {
    return useQuery({
        queryKey: signalsQueryKeys.accountSettings(),
        queryFn: () => salesApiService.signals.getAccountSettings(),
        staleTime: Number.POSITIVE_INFINITY,
    });
};
